export default __webpack_public_path__ + "static/media/candy.13ce273d.svg";